import { useState, useMemo, useCallback } from "react";
import {
  DEFAULT_BATCH_TRANSACTIONS_FILTERS,
  DEFAULT_BATCH_TRANSACTIONS_PAGINATION,
} from "../constants/batchTransactionsConstants";

export const useBatchTransactionsFilters = () => {
  const [filters, setFilters] = useState(DEFAULT_BATCH_TRANSACTIONS_FILTERS);
  const [pagination, setPagination] = useState(
    DEFAULT_BATCH_TRANSACTIONS_PAGINATION,
  );

  const apiFilters = useMemo(() => {
    const { searchQuery, dateRange, status } = filters;
    return {
      searchQuery: searchQuery || "",
      status: status === "all" ? "" : status,
      startDate: dateRange?.startDate || "",
      endDate: dateRange?.endDate || "",
      page: pagination.pageIndex,
      size: pagination.pageSize,
    };
  }, [filters, pagination.pageIndex, pagination.pageSize]);

  const resetPagination = useCallback(() => {
    setPagination((prev) => ({ ...prev, pageIndex: 0 }));
  }, []);

  const setSearchQuery = useCallback(
    (query) => {
      setFilters((prev) => ({ ...prev, searchQuery: query }));
      resetPagination();
    },
    [resetPagination],
  );

  const setDateRange = useCallback(
    (rangeOutput) => {
      setFilters((prev) => ({
        ...prev,
        dateRange: {
          startDate: rangeOutput?.startDate || null,
          endDate: rangeOutput?.endDate || null,
        },
      }));
      resetPagination();
    },
    [resetPagination],
  );

  const setStatus = useCallback(
    (value) => {
      setFilters((prev) => ({ ...prev, status: value || "all" }));
      resetPagination();
    },
    [resetPagination],
  );

  return {
    filters,
    pagination,
    apiFilters,
    setPagination,
    resetPagination,
    searchQuery: filters.searchQuery,
    dateRange: filters.dateRange,
    status: filters.status,
    setSearchQuery,
    setDateRange,
    setStatus,
  };
};

export default useBatchTransactionsFilters;
